import React from 'react';
import { Image } from '@front10/base-elements';
import { getResizedImage } from '../../../helpers/images';

export interface ImageProps {
  image: string;
  altText: string;
  size?: undefined | 'small' | 'big';
}

export function EventImage({ image, altText, size }: ImageProps) {
  const newUrl = getResizedImage(image, {
    quality: 80,
    format: 'auto',
    opt: true,
    height: size === 'big' ? 600 : 300,
    width: size === 'big' ? 800 : 400
  });

  return (
    <Image
      alt={altText || ''}
      src={newUrl}
      decoding="async"
      sx={{ height: '100%', width: '100%', objectFit: 'cover' }}
    />
  );
}

export default EventImage;
